/* eslint-disable react/jsx-key */
import styles from './InsightsCardGI.module.scss';
import InsightsCard from '../insights-card/InsightsCard';
import { useAppSelector } from '@customer/store/hooks';
import { GIType, GISummaryModel } from '@customer/store/apis/interactionsApi';
import { useMemo } from 'react';
import Metric, { MetricSize } from '../metric/Metric';
import { useTranslation } from 'react-i18next';

// Remove "Unknown" and "GeofenceSpeedingRoadworks" from the list
const GI_TYPES: GIType[] = Object.values(GIType).filter(
  it => it !== GIType.Unknown && it !== GIType.GeofenceSpeedingRoadworks,
);

interface GISummary {
  it: GIType;
  count?: number | null;
}

interface InsightsCardGIProps {
  records?: GISummaryModel[];
}

export function InsightsCardGI({ records }: InsightsCardGIProps) {
  const { t } = useTranslation();

  const giFilter = useAppSelector(state => state.filters.saved.geofenceInteractionTypes);

  const summaries = useMemo<GISummary[]>(() => {
    return GI_TYPES.map((it: GIType) => {
      const record = records?.find((record: GISummaryModel) => record.it === it);

      // if not filtered, or included in filters, then return the count number when it has loaded.
      // If no matching record is found after the api response, return 0.
      // Special handling needed for SpeedingRoadworks as this is combined into Speeding
      const showCount =
        giFilter === undefined ||
        giFilter.length === 0 ||
        giFilter.includes(it) ||
        (it === GIType.GeofenceSpeeding && giFilter.includes(GIType.GeofenceSpeedingRoadworks));

      const count = showCount ? (records ? (record ? record.cnt : 0) : undefined) : null;

      return { it, count };
    });
  }, [records, giFilter]);

  return (
    <InsightsCard
      cols={1}
      sections={[
        <div
          className={styles.metrics}
          style={{ '--gi-cols': summaries.length } as React.CSSProperties}
        >
          {summaries.map(({ it, count }: GISummary) => {
            return (
              <div className={styles.metric} key={it}>
                <Metric dataPrimary={count} label={t(`gi.name.${it}`)} size={MetricSize.XL} />
              </div>
            );
          })}
        </div>,
      ]}
    />
  );
}

export default InsightsCardGI;
